import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
const G_SecondRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            G_del_dis,
            G_anotherInputWakil,
            G_frosht,
            G_joripara,
            G_mob,
            G_nawe_barez,
            G_zh_barez,
            G_search_wakil,
            toanotherInput,
            G_wargr,
            G_toAnotherRow
          } = value;
          return (
            <>
              <form>
                <div className="row">
                  <div className="col-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">بەڕێز</label>
                      <input
                        type="text"
                        disabled={G_del_dis == true ? true : null}
                        value={G_nawe_barez}
                        name="G_nawe_barez"
                        onKeyPress={(event) =>
                          event.key == "Enter" ? G_toAnotherRow(event) : null
                        }
                        onChange={AddProChange}
                        className={`form-control text-right font-weight-bold ${
                          G_frosht == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${
                                G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                  ? "bg-danger text-white"
                                  : ""
                              }`
                        }`}
                      />
                    </div>
                  </div>

                  <div className="col-4 text-right mt-2">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کۆد.وەکیل</label>
                      <input
                        type="text"
                        value={G_zh_barez > 0 ? G_zh_barez : ""}
                        disabled={
                          G_search_wakil == true ||
                          G_frosht == "فرۆشتنی ڕاستەوخۆ" ||
                          G_frosht == null ||
                          G_del_dis == true
                            ? true
                            : null
                        }
                        name="G_zh_barez"
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? G_anotherInputWakil(event)
                            : null
                        }
                        onChange={AddProChange}
                        className={`form-control text-right font-weight-bold  ${
                          G_frosht == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${G_frosht == "فرۆشتنی ڕاستەوخۆ" ? "" : ""}`
                        }`}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 text-right mt-2">
                    <label className="font-weight-bold f4">جۆری فرۆشتن</label>
                    <select
                      disabled={G_del_dis == true ? true : null}
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        G_frosht == "فرۆشتنی وەکیل"
                          ? "bg-success text-white"
                          : `${
                              G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      onKeyPress={(event) =>
                        event.key == "Enter" ? toanotherInput(event) : null
                      }
                      name="G_frosht"
                      value={G_frosht != null ? G_frosht : ""}
                    >
                      <option className="ml5">جۆری فرۆشتن</option>
                      <option> فرۆشتنی وەکیل</option>
                      <option> فرۆشتنی ڕاستەوخۆ</option>
                    </select>
                  </div>
                </div>
                {/*seconnd row  */}
                <div className="row card-header p-1 border-bottom border-warning">
                  <div className="col-4 text-right">
                    <label className="font-weight-bold f4">ناوی وەرگر</label>
                    <select
                      disabled={G_del_dis == true ? true : null}
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        G_wargr == "یوسف"
                          ? "bg-success text-white"
                          : `${
                              G_wargr == "یوسف"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      name="G_wargr"
                      value={G_wargr != null ? G_wargr : ""}
                    >
                      <option className="ml5">ناوی وەرگر</option>
                      <option>یوسف</option>
                      <option>یوسف</option>
                    </select>
                  </div>
                  <div className="col-sm-4 text-right">
                    <label className="font-weight-bold f4">جۆری دراو</label>
                    <select
                      className={`form-control text-right font-weight-bold selectpicker pull-right ${
                        G_joripara == "دۆلار"
                          ? "bg-success text-white"
                          : `${
                              G_joripara == "دینار"
                                ? "bg-danger text-white"
                                : ""
                            }`
                      }`}
                      onChange={AddProChange}
                      onKeyPress={(event) =>
                        event.key == "Enter" ? toanotherInput(event) : null
                      }
                      name="G_joripara"
                      value={G_joripara != null ? G_joripara : ""}
                    >
                      <option
                        className="ml5"
                        disabled={G_joripara != null ? true : null}
                      >
                        جۆری دراو
                      </option>
                      <option disabled={G_joripara == "دینار" ? true : null}>
                        دۆلار
                      </option>
                      <option disabled={G_joripara == "دۆلار" ? true : null}>
                        دینار
                      </option>
                    </select>
                  </div>
                  <div className="col-sm-4 text-right ">
                    <div className="form-group">
                      <label className="font-weight-bold f4">تەلەفۆن</label>
                      <input
                        type="number"
                        disabled={G_del_dis == true ? true : null}
                        value={G_mob}
                        name="G_mob"
                        onChange={AddProChange}
                        onKeyPress={(event) =>
                          event.key == "Enter" ? toanotherInput(event) : null
                        }
                        className={`form-control text-right font-weight-bold ${
                          G_frosht == "فرۆشتنی وەکیل"
                            ? "bg-success text-white"
                            : `${
                                G_frosht == "فرۆشتنی ڕاستەوخۆ"
                                  ? "bg-danger text-white"
                                  : ""
                              }`
                        }`}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default G_SecondRow;
